import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import LoginForm from './components/auth/LoginForm';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import Dashboard from './components/dashboard/Dashboard';
import AdminDashboard from './components/dashboards/AdminDashboard/AdminDashboard';
import AdminUsers from './components/admin/AdminUsers';
import AdminMilestones from './components/admin/AdminMilestones';
import AdminScheduling from './components/admin/AdminScheduling';
import AdminPdiProgress from './components/admin/AdminPdiProgress';
import AdminRatings from './components/admin/AdminRatings';
import AdminAdvisory from './components/admin/AdminAdvisory';
import AdminRelationships from './components/admin/AdminRelationships/AdminRelationships';
import AdminNewSession from './components/admin/AdminNewSession';
import AdminReports from './components/admin/AdminReports';
import AdminSettings from './components/admin/AdminSettings';
import AdminAuditLogs from './components/admin/AdminAuditLogs';
import AdminResources from './components/admin/AdminResources';
import AdminEmails from './components/admin/AdminEmails';
import AdminAnalytics from './components/admin/AdminAnalytics';
import MentorDashboard from './components/mentor/MentorDashboard';
// import MentorEvaluations from './components/mentor/MentorEvaluations';
import MentorMentees from './components/mentor/MentorMentees';
import MenteeDetailPage from './components/mentor/MenteeDetailPage';
import MentorSessions from './components/mentor/MentorSessions';
import NewSessionPage from './components/mentor/NewSessionPage';
import EditSessionPage from './components/mentor/EditSessionPage';
import SessionDetailPage from './components/mentor/SessionDetailPage';
import MentorResources from './components/mentor/MentorResources';
import MentorAdvisory from './components/mentor/MentorAdvisory';
import MentorCalendar from './components/mentor/MentorCalendar';
import MenteeDashboard from './components/mentee/MenteeDashboard';
import MenteeSessions from './components/mentee/MenteeSessions';
import MenteeResources from './components/mentee/MenteeResources';
import PlanFlow from './components/plan/PlanFlow';
import NotificationsPage from './components/common/NotificationsPage';
import MenteeCalendar from './components/mentee/MenteeCalendar';
import ProtectedRoute from './components/common/ProtectedRoute';
import { ToastHost } from './components/common/Toaster';
import ProfilePage from './components/profile/ProfilePage';
import ContactPage from './components/contact/ContactPage';
import MensajeriaPage from './components/messaging/MensajeriaPage';
import LegalPage from './components/legal/LegalPage';
import GuidePage from './components/guide/GuidePage';
import './styles/global.scss';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<LoginForm />} />
            {/* Registro deshabilitado: es un programa cerrado con usuarios asignados */}
            <Route path="/register" element={<Navigate to="/login" replace />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            {/* Admin Routes */}
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute allowedRoles={['super_admin', 'admin']}>
                  <Routes>
                    <Route path="dashboard" element={<AdminDashboard />} />
                    <Route path="users" element={<AdminUsers />} />
                    <Route path="relationships" element={<AdminRelationships />} />
                    <Route path="milestones" element={<AdminMilestones />} />
                    <Route path="scheduling" element={<AdminScheduling />} />
                    <Route path="pdi-progress" element={<AdminPdiProgress />} />
                    <Route path="ratings" element={<AdminRatings />} />
                    <Route path="advisory" element={<AdminAdvisory />} />
                    <Route path="sessions/new" element={<AdminNewSession />} />
                    <Route path="stages" element={<Navigate to="dashboard" replace />} />
                    <Route path="plan" element={<PlanFlow key="admin-plan" />} />
                    <Route path="reports" element={<AdminReports />} />
                    <Route path="resources" element={<AdminResources />} />
                    <Route path="emails" element={<AdminEmails />} />
                    <Route path="analytics" element={<AdminAnalytics />} />
                    <Route path="settings" element={<AdminSettings />} />
                    <Route path="audit-logs" element={<AdminAuditLogs />} />
                    <Route path="notifications" element={<NotificationsPage />} />
                    <Route index element={<Navigate to="dashboard" replace />} />
                  </Routes>
                </ProtectedRoute>
              }
            />

            {/* Rutas de Mentor */}
            <Route
              path="/mentor/*"
              element={
                <ProtectedRoute allowedRoles={['mentor']}>
                  <Routes>
                    <Route path="dashboard" element={<MentorDashboard />} />
                    <Route path="mentees" element={<MentorMentees />} />
                    <Route path="plan" element={<PlanFlow key="mentor-consent" only="consent" />} />
                    <Route path="mentees/:id" element={<MenteeDetailPage />} />
                    <Route path="sessions" element={<MentorSessions />} />
                    <Route path="sessions/new" element={<NewSessionPage />} />
                    <Route path="sessions/:id" element={<SessionDetailPage />} />
                    <Route path="sessions/:id/edit" element={<EditSessionPage />} />
                    <Route path="calendar" element={<MentorCalendar />} />
                    <Route path="resources" element={<MentorResources />} />
                    <Route path="advisory" element={<MentorAdvisory />} />
                    {/* <Route path="evaluations" element={<MentorEvaluations />} /> */}
                    <Route path="notifications" element={<NotificationsPage />} />
                    <Route index element={<Navigate to="dashboard" replace />} />
                  </Routes>
                </ProtectedRoute>
              }
            />

            {/* Rutas de Mentee */}
            <Route
              path="/mentee/*"
              element={
                <ProtectedRoute allowedRoles={['mentee']}>
                  <Routes>
                    <Route path="dashboard" element={<MenteeDashboard />} />
                    <Route path="sessions" element={<MenteeSessions />} />
                    <Route path="calendar" element={<MenteeCalendar />} />
                    <Route path="resources" element={<MenteeResources />} />
                    <Route path="plan" element={<PlanFlow key="mentee-plan" only="plan" />} />
                    <Route path="agreement" element={<PlanFlow key="mentee-agreement" only="consent" />} />
                    {/* Progreso y Objetivos ahora viven en el Dashboard */}
                    <Route path="progress" element={<Navigate to="../dashboard" replace />} />
                    <Route path="goals" element={<Navigate to="../dashboard" replace />} />
                    <Route path="notifications" element={<NotificationsPage />} />
                    <Route index element={<Navigate to="dashboard" replace />} />
                  </Routes>
                </ProtectedRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />

            <Route path="/contact" element={<ContactPage />} />
            <Route
              path="/mensajeria"
              element={
                <ProtectedRoute>
                  <MensajeriaPage />
                </ProtectedRoute>
              }
            />
            <Route path="/legal/:doc" element={<LegalPage />} />
            <Route path="/guia/:role" element={<GuidePage />} />

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
          <ToastHost />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
